import * as React from "react";
import {
  SelectInput,
  required,
  ArrayInput,
  SimpleFormIterator,
  TextInput,
  maxValue,
  minValue,
  NumberInput,
  SelectArrayInput,
} from "react-admin";
import {
  GAS_BRAND_MERCHANT_STATUSES,
  FUEL_TYPES,
} from "@local/app/constants/index.js";
import { validateTextInput } from "../../../shared/components/index.js";

const EditGasBrandMerchantInfo = () => (
  <SelectInput
    sx={{
      width: "20%",
      "@media (max-width:900px)": {
        width: "100%",
      },
    }}
    source="qr_type"
    validate={[required()]}
    choices={[
      { id: "Datex", name: "Datex" },
      { id: "ITBI", name: "ITBI" },
    ]}
  />
);

const EditGasBrandMerchantFuel = () => (
  <ArrayInput
    source="fuels"
    label=""
    sx={{
      width: "50%",
      "@media (max-width:1000px)": {
        width: "100%",
      },
    }}
  >
    <SimpleFormIterator
      inline
      disableClear={true}
      disableReordering={true}
      disableRemove={true}
    >
      <SelectInput
        sx={{
          width: "100%",
          "@media (max-width:1000px)": {
            width: "100%",
          },
        }}
        source="name"
        label="resources.GasBrandMerchant.fuels.name"
        validate={[required()]}
        choices={Object.keys(FUEL_TYPES).map((fuel) => ({
          id: fuel,
          name: fuel,
        }))}
        optionText="name"
        optionValue="id"
      />
      <NumberInput
        sx={{
          width: "100%",
          "@media (max-width:1000px)": {
            width: "100%",
          },
        }}
        source="regular_price"
        label="resources.GasBrandMerchant.fuels.regular_price"
        validate={[required(), maxValue(2147483647), minValue(0)]}
      />
      <SelectInput
        sx={{
          width: "100%",
          "@media (max-width:1000px)": {
            width: "100%",
          },
        }}
        source="status"
        label="resources.GasBrandMerchant.fuels.status"
        validate={[required()]}
        choices={Object.keys(GAS_BRAND_MERCHANT_STATUSES).map((status) => {
          if (status === "blocked") {
            return;
          }

          return {
            id: status,
            name: `resources.GasBrandMerchant.source.status.${status}`,
          };
        })}
      />
    </SimpleFormIterator>
  </ArrayInput>
);

const EditGasBrandMerchantCoords = () => {
  return (
    <ArrayInput source="coordinates" label="">
      <SimpleFormIterator inline disableClear disableReordering disableRemove>
        <TextInput
          sx={{
            width: "100%",
            "@media (max-width:900px)": {
              width: "100%",
            },
          }}
          inputProps={{ maxLength: 55, minLength: 1 }}
          source="name"
          label="resources.Coordinate.fields.name"
          validate={[required(), validateTextInput]}
        />
        <TextInput
          sx={{
            width: "100%",
            "@media (max-width:900px)": {
              width: "100%",
            },
          }}
          source="address"
          label="resources.Coordinate.fields.address"
          validate={[required(), validateTextInput]}
          multiline
        />
        <NumberInput
          sx={{
            width: "100%",
            "@media (max-width:900px)": {
              width: "100%",
            },
          }}
          source="lat"
          label="resources.Coordinate.fields.lat"
          validate={[
            required(),
            maxValue(2147483647),
            minValue(1, "resources.notifications.errors.invalid_syntax"),
          ]}
        />
        <NumberInput
          sx={{
            width: "100%",
            "@media (max-width:900px)": {
              width: "100%",
            },
          }}
          source="long"
          label="resources.Coordinate.fields.long"
          validate={[
            required(),
            maxValue(2147483647),
            minValue(1, "resources.notifications.errors.invalid_syntax"),
          ]}
        />
        <SelectArrayInput
          label="resources.Coordinate.fields.fuel_types_as_object"
          source="fuel_types"
          choices={Object.keys(FUEL_TYPES).map((fuel) => ({
            id: fuel,
            name: fuel,
          }))}
          optionText="name"
          optionValue="id"
          validate={[required()]}
        />
        <SelectInput
          sx={{
            width: "100%",
            "@media (max-width:900px)": {
              width: "100%",
            },
          }}
          source="status"
          label="resources.GasBrandMerchant.fields.status"
          validate={[required()]}
          choices={Object.keys(GAS_BRAND_MERCHANT_STATUSES)
            .filter((status) => status !== "blocked")
            .map((status) => ({
              id: status,
              name: `resources.GasBrandMerchant.source.status.${status}`,
            }))}
        />
      </SimpleFormIterator>
    </ArrayInput>
  );
};

export {
  EditGasBrandMerchantFuel,
  EditGasBrandMerchantCoords,
  EditGasBrandMerchantInfo,
};
